<template>
    <div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                    Angebotsvorlage Texte
                </h3>
            </div>
        </div>
        <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
                <li class="m-portlet__nav-item">
                    <a href="/angebots-vorlagen-texte/create" class="m-portlet__nav-link m-portlet__nav-link--icon btn btn-brand" title="Neue Vorlage">
                        <i class="la la-plus"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <!--begin::Form-->
    <form class="m-form m-form--fit m-form--label-align-right">
        <div class="m-portlet__body">
            <div class="offer-template-overview container">
                <el-table
                    :data="OfferTemplateParts"
                    style="width: 100%"
                    align="top">
                    <el-table-column
                        prop="id" label="ID" width="70" sortable>
                    </el-table-column>
                    <el-table-column
                        prop="name" label="Name" sortable>
                    </el-table-column>
                    <el-table-column width="120" label="Aktionen">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="linkTo(scope.row.id)" >Bearbeiten</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </form>
    </div>
</template>

<script>
    export default{
        props: {
            OfferTemplateParts: Array
        },
        methods:{
            linkTo(link){
                window.location.href = "/angebots-vorlagen-texte/" + link + "/";
            }
        }
    }
</script>
